
    const data = {"name":"src/core/icons/email-alert","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m18 8-8 5-8-5V6l8 5 8-5m0-2H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m6 3h-2v6h2V7m0 8h-2v2h2v-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            